<template>
<b-container class="bv-example-row">
    <Header></Header>
    <b-row>
      <b-col cols="12" class="hr"></b-col>
    </b-row>
    <b-row>
        <b-col cols="3">
          <Menu></Menu>
        </b-col>
        <b-col cols="9" class="border">
          <b-row>
            <b-col cols="12">
              <b-row>
                <b-col cols="12">
                  <b-row>
                    <b-col cols="12" class="head">
                      <h4>:: Modelos</h4>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" class="breadcrumb">
                      <b-link :href="'/models-by-brand/model/'+ model.slug">Modelos</b-link> &raquo; Editar:
                    </b-col>
                  </b-row>
                  <div class="mt-2"></div>
                  <b-form @submit="onSubmit" class="pb-4">
                    <b-form-group id="f_name"
                              horizontal
                              :label-cols="4"
                              breakpoint="md"
                              label="Nombre del Modelo">
                      <b-form-input id="name" :state="state" v-model.trim="model.name"></b-form-input>
                    </b-form-group>
                    <b-form-group id="f_name"
                              horizontal
                              :label-cols="4"
                              breakpoint="md"
                              label="URL de la imagen">
                      <b-form-input id="name" :state="state" v-model.trim="model.image"></b-form-input>
                    </b-form-group>
                    <b-button type="submit" variant="primary derco">Actualizar</b-button>
                  </b-form>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
    </b-row>
  </b-container>
</template>

<script>
/*eslint-disable */
import axios from 'axios'
import Header from './Header'
import Menu from './Menu'
export default {
  name: 'EditModel',
  components:{
    Header,
    Menu
  },
  data () {
    return {
      model: []
    }
  },
  created () {
    if(localStorage.getItem('role')=="Administrador"){
      document.title = 'Administración Derco - Editar Marca'
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.get(`/models/` + this.$route.params.id)
      .then(response => {
        this.model = response.data
      })
      .catch(e => {
        this.errors.push(e)
      })
    }else{
      this.$router.push({
        name: 'Login'
      })
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
      axios.put(`/models/` + this.$route.params.id, this.model)
      .then(response => {
        this.$router.push({
          name: 'ShowModel',
          params: { id: this.$route.params.id }
        })
      })
      .catch(e => {
        this.errors.push(e)
      })
    }
  }
}
</script>
<style>
.form-row legend{
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/EditModel.vue